export default "__VITE_ASSET__DWIR1c$b__"